import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import AllProduct from '../views/AllProduct.vue'
import AddProduct from '../views/AddProductPage.vue'
import EditProduct from '../views/EditProductPage.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/all-product',
    name: 'AllProduct',
    component: AllProduct
  },
  {
    path: '/all-product/add-product',
    name: 'AddProduct',
    component: AddProduct
  },
  {
    path: '/all-product/edit/:id',
    name: 'EditProduct',
    component: EditProduct
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
